export const ACCOUNT_STATUS_OPTIONS = [
    { id: "pending", label: "Pending" },
    { id: "pending_review", label: "Pending Review" },
    { id: "verified", label: "Verified" },
    { id: "rejected", label: "Rejected" },
    { id: "noteligible", label: "Not Eligible" },
    { id: "banned", label: "Banned" },
    { id: "default", label: "Unavailable" },
];

export const ACCOUNT_STATUS_CHIP_STYLES = {
    pending: {
        backgroundColor: "rgba(245, 158, 11, 0.14)",
        borderColor: "rgba(245, 158, 11, 0.55)",
        color: "#FBBF24",
    },
    pending_review: {
        backgroundColor: "rgba(255, 167, 38, 0.18)",
        borderColor: "rgba(255, 167, 38, 0.44)",
        color: "#FFB74D",
    },
    verified: {
        backgroundColor: "rgba(34, 197, 94, 0.14)",
        borderColor: "rgba(34, 197, 94, 0.32)",
        color: "#86EFAC",
    },
    rejected: {
        backgroundColor: "rgba(244, 67, 54, 0.18)",
        borderColor: "rgba(244, 67, 54, 0.4)",
        color: "#FCA5A5",
    },
    noteligible: {
        backgroundColor: "rgba(171, 71, 188, 0.18)",
        borderColor: "rgba(171, 71, 188, 0.4)",
        color: "#E9D5FF",
    },
    banned: {
        backgroundColor: "rgba(144, 164, 174, 0.22)",
        borderColor: "rgba(144, 164, 174, 0.36)",
        color: "#E2E8F0",
    },
    default: {
        backgroundColor: "rgba(255,255,255,0.08)",
        borderColor: "rgba(255,255,255,0.18)",
        color: "rgba(255,255,255,0.92)",
    },
};

export function getProfileTrustFactor(user) {
    const value = Number(user?.profileTrustFactor);
    if (Number.isFinite(value)) {
        return Math.max(1, Math.min(10, value));
    }
    return 1;
}

export function getAccountStatusLabel(user) {
    const display = user?.accountDisplayStatus;
    if (typeof display === "string" && display.trim()) {
        return display.trim();
    }

    const status = user?.accountStatus;
    if (typeof status === "string" && status.trim()) {
        return status.replace(/_/g, " ");
    }

    return "Status unavailable";
}

export function getAccountStatusChipStyle(accountStatus) {
    return (
        ACCOUNT_STATUS_CHIP_STYLES[accountStatus] || ACCOUNT_STATUS_CHIP_STYLES.default
    );
}

export function formatProfileTrustTier(value) {
    if (typeof value !== "string" || !value.trim()) {
        return null;
    }

    return value
        .trim()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
}
